function edQuickAdd() {
  var $formContainer = $(".block-inner-inner")
  $formContainer.find("form.ed-quickadd-form").each(function () {
    var $form = $(this)
    var addBtn = $form.find(".js-go-cart-add-to-cart.svgcart")
    $form.on("submit", function (evt) {
      // Ajax-add
      if (theme.settings.after_add_to_cart !== "no-js") {
        evt.preventDefault()
        var shopifyAjaxAddURL = theme.routes.cart_add_url
        //Disable add button
        $form
          .find('button[type="submit"]')
          .attr("disabled", "disabled")
          .each(function () {
            if ($(this).hasClass("btn--added")) {
              clearTimeout($(this).data("revertAddToCartTextTimeoutID"))
            } else {
              $(this).data("previous-value", $(this).html())
            }
          })
          .html('<div class="loading-spinner loading-spinner--in-btn"></div>')

        $form.find('button[type="submit"]').each(function () {
          setTimeout(() => {
            $(this).html(addBtn)
          }, 6000)
        })

        //Add to cart
        var formData = new FormData($form[0])
        formData.append("sections", "cart-drawer")

        setTimeout(function () {
          let upsellBtns = document.querySelectorAll(".upsellbtn")
          let upsellScroller = document.querySelector(".ed-cart-upsell")
          let childWidth = upsellScroller.children[0].offsetWidth

          function upsellScrollerFunc(upsellBtn) {
            if (upsellBtn.id == "left-scroll") {
              upsellScroller.style.scrollBehavior = "smooth"
              upsellScroller.scrollLeft -= childWidth
              upsellScroller.style.scrollBehavior = "unset"
            } else if (upsellBtn.id == "right-scroll") {
              upsellScroller.style.scrollBehavior = "smooth"
              upsellScroller.scrollLeft += childWidth
              upsellScroller.style.scrollBehavior = "unset"
            }
          }

          for (let upsellBtn of upsellBtns) {
            upsellBtn.addEventListener("click", function (event) {
              event.preventDefault()
              upsellScrollerFunc(upsellBtn)
            })
          }
        }, 2500)

        $.post(
          shopifyAjaxAddURL,
          new URLSearchParams(formData).toString(),
          theme.addedToCartHandler.bind($form),
          "json"
        ).fail(function (data) {
          //Enable add button
          $form
            .find('button[type="submit"]')
            .removeAttr("disabled")
            .each(function () {
              setTimeout(() => {
                $(this).html(addBtn)
              }, 3500)
            })
          //Not added, show message
          if (typeof data !== "undefined" && typeof data.status !== "undefined") {
            var jsonRes = $.parseJSON(data.responseText)
            theme.showQuickPopup(jsonRes.description, $form.find('button[type="submit"]:first'))
          } else {
            //Some unknown error? Disable ajax and add the old-fashioned way.
            $formContainer.attr("ajax-add-to-cart", "false")
            $form.submit()
          }
        })
      }
    })
  })

  var ccCollectionSelectBtns = document.querySelectorAll(".cc-select__button.collection")
  var ccCollectionSelectOptions = document.querySelectorAll(".cc-select__option.js-option.quick")
  if (ccCollectionSelectBtns) {
    var parentContainers = document.querySelectorAll(".product-block")
    for (var parentContainer of parentContainers) {
      parentContainer.addEventListener("mouseenter", function () {
        event.stopPropagation()
        var formParent = this.querySelector(".ed-quickadd")
        var selectParent = formParent.querySelector(".cc-select__listbox")
        selectParent.style.visibility = "hidden"
      })
    }

    for (var ccCollectionSelectBtns of ccCollectionSelectBtns) {
      ccCollectionSelectBtns.addEventListener("click", function () {
        var formParent = this.closest(".ed-quickadd")
        var selectParent = formParent.querySelector(".cc-select__listbox")
        var listBoxEles = document.querySelectorAll(".cc-select__listbox")
        for (var listBoxEle of listBoxEles) {
          listBoxEle.style.visibility = "hidden"
        }
        selectParent.style.visibility = "visible"
      })
    }

    // check that url does not contain "products"
    var url = window.location.href

    for (var ccCollectionSelectOption of ccCollectionSelectOptions) {
      ccCollectionSelectOption.addEventListener("click", function () {
        var optionValue = this.getAttribute("value")
        var optionName = this.getAttribute("data-name")

        if (this.getAttribute("data-udsolgt") === "true") {
          const viewport = document.querySelector('meta[name="viewport"]')
          viewport.content = "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
          var parentEle = this.closest(".ed-quickadd")
          var addToCart = parentEle.querySelector(".js-go-cart-add-to-cart")
          var iconAddtoCart = parentEle.querySelector(".js-go-cart-add-to-cart.svgcart")
          var correctEle = parentEle.querySelector('.hiddenvariants a[data-variant-id="' + optionValue + '"]')
          correctEle.click()
          addToCart.setAttribute("disabled", "disabled")
          iconAddtoCart.style.pointerEvents = "none"
          setTimeout(() => {
            correctEle.click()
          }, 500)
        } else {
          var parentEle = this.closest(".ed-quickadd")
          console.log("parentEle", parentEle)
          var addToCart = parentEle.querySelector(".js-go-cart-add-to-cart")
          console.log("addToCart", addToCart)
          var iconAddtoCart = parentEle.querySelector(".js-go-cart-add-to-cart.svgcart")
          console.log("iconAddtoCart", iconAddtoCart)
          var idInput = parentEle.querySelector(".product-select")
          console.log("idInput", idInput)
          var formId = this.closest(".ed-quickadd-form")
          console.log("formId", formId)
          var formIdCurrent = this.getAttribute("id")
          console.log("formIdCurrent", formIdCurrent)
          var formIdNew = formIdCurrent + optionValue + optionValue
          console.log("formIdNew", formIdNew)

          idInput.value = optionValue
          console.log("idInput.value", idInput.value)
          formId.setAttribute("id", formIdNew)
          if (optionValue.value == "Vælg størrelse") {
            addToCart.setAttribute("disabled", "disabled")
            iconAddtoCart.style.pointerEvents = "none"
          } else {
            addToCart.removeAttribute("disabled")
            iconAddtoCart.style.pointerEvents = "auto"
          }
        }
        var parentEle = this.closest(".ed-quickadd")
        var selectList = parentEle.querySelector(".cc-select__listbox")
        selectList.style.visibility = "hidden"
        var selectButton = parentEle.querySelector(".cc-select__button.collection")
        setTimeout(() => {
          optionArrName = optionName.split("-")
          if (optionArrName[1] !== undefined) {
            selectButton.innerHTML = `<span class="tw-font-medium">${optionArrName[0]}</span> <span>${optionArrName[1]}</span>`
          } else {
            selectButton.innerHTML = `<span class="tw-font-medium">${optionArrName[0]}</span>`
          }
        }, 1)
      })
    }
  }
}


window.addEventListener("load", (event) => {
  edQuickAdd()
})

// fejl meddelelse hvis en besøgende prøver at tilmelde sig nyhedsbrevet med en email der allerede er tilmeldt
var urlNoSignup = window.location.href
var newsletterForm = document.getElementById("cc-popup")
var footerNewsletterForm = document.getElementById("footer_newsletter_signup")

if (newsletterForm) {
  newsletterForm.addEventListener("submit", function (event) {
    localStorage.setItem("formSubmitted", "true")
  })
}

if (footerNewsletterForm) {
  footerNewsletterForm.addEventListener("submit", function (event) {
    localStorage.setItem("formSubmitted", "true")
  })
}

if (localStorage.getItem("formSubmitted")) {
  if (urlNoSignup.includes("?contact%5Btags%") || urlNoSignup.includes("?%5Bnote") || urlNoSignup.includes("%5Bnote")) {
    var newPopup = document.querySelector(".section-popup.cc-popup.cc-popup--center")
    if (newPopup) {
      newPopup.classList.add("cc-popup--visible")
      var popupTextWrapper = document.querySelector(".cc-popup-text")
      var currentError = document.querySelector(".error-message")
      var errorMessage = document.createElement("div")
      var errorMessageText = document.createElement("div")
      errorMessage.classList.add("cc-popup-form__response-ed")
      errorMessage.classList.add("cc-popup-form__response--error")
      errorMessageText.classList.add("error-message")
      errorMessageText.style.color = "red"
      errorMessage.appendChild(errorMessageText)
      popupTextWrapper.appendChild(errorMessage)
      if (currentError) {
        currentError.remove()
      }

      errorMessageText.innerHTML = "Denne e-mail er allerede tilmeldt."
      errorMessage.style.margin = "0"

      var emptyEmailMessageError = document.querySelector(".cc-popup-form__response.cc-popup-form__response--error")
      emptyEmailMessageError.remove()
      localStorage.removeItem("formSubmitted")
    } else {
      alert("Denne e-mail er allerede tilmeldt.")
      localStorage.removeItem("formSubmitted")
    }
  }
}

// check "in stock" hvis der klikkes på et størrelsesfilter

function filterCheck() {
  const checkboxes = document.querySelectorAll('input[type="checkbox"][name="filter.v.option.størrelse"]')
  let isChecked = false

  checkboxes.forEach((checkbox) => {
    if (checkbox.checked) {
      isChecked = true
    }
  })

  if (isChecked) {
    document.getElementById("Filter-filter.v.availability-2").click()
  } else {
    document.getElementById("Filter-filter.v.availability-1").click()
  }
}

// readmore on collctions
var readmore = document.querySelector("#read_more")
var fullDescription = document.querySelector("#full_description")

if (readmore) {
  readmore.addEventListener("click", function () {
    var scrollOffset = fullDescription.getBoundingClientRect().top + window.pageYOffset - 150
    window.scrollTo({ top: scrollOffset, behavior: "smooth" })
  })
}

/* Kommentart CC
Følgende er modificeret kode af Shopheltens gamle kode til at vise sold out tekst mm. på variantvælger dropdown på product pages.

Første del af koden med at displaye sold out tekst på varintvælger dropdownen virkede ikke, da der var lidt fejl.

Shopheltens const ListItems targede alle sdoption muligheder i dropdowns som var på dommen,
i stedet for kun den dropdown som lagde i .input-row på product siden.

Dette er nu ændret, så funktionen nu kører som den skal.

Ligeledes er der tilføjet lidt quality of life, så BIS_trigget skjules hvis der vægles en ny variant (Efter man har trykket på en udsolgt en)


*/

$(function () {
  // Display Sold-out text on dropdown-button.
  const listItems = document.querySelectorAll(".input-row li.cc-select__option")
  const button = document.querySelector(".input-row button.cc-select__btn")
  const addToCartBtn = document.querySelector("#AddToCart")
  const preorderBox = document.querySelector(".button__preorder")
  const dropdownArrow =
    '<svg class="cc-select__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>'

  listItems.forEach((item) => {
    if (item.getAttribute("aria-selected")) {
      let statusText = ""
      if (item.classList.contains("is-unavailable")) {
        statusText =
          '<span class="sold-out-label" style="margin-left: auto; display: flex; align-items: center;">' +
          theme.strings.products_labels_sold_out +
          ' <span class="tilmeld-liste"><a href="#" class="BIS_trigger" style="display: flex; align-items: center; text-decoration: underline !important; cursor: pointer;"><img height="15" width="15" style="margin: 0 5px;" src="https://cdn.shopify.com/s/files/1/0612/2258/4473/files/mail.png?v=1653398586" alt=""> ' +
          theme.strings.products_labels_be_notified +
          "</a></span></span>"
      }

      if (item.dataset.preorder == "true") {
        preorderText = `<span> ${theme.strings.products_preorder}</span>`
      } else {
        preorderText = ""
      }

      button.innerHTML =
        '<span class="tw-font-medium">' + item.dataset.value + "</span>" + statusText + preorderText + dropdownArrow
    }

    item.addEventListener("click", (e) => {
      let statusText = ""
      if (item.classList.contains("is-unavailable")) {
        statusText =
          '<span class="sold-out-label" style="margin-left: auto; display: flex; align-items: center;">' +
          theme.strings.products_labels_sold_out +
          ' <span class="tilmeld-liste"><a href="#" class="BIS_trigger" style="display: flex; align-items: center; text-decoration: underline !important; cursor: pointer;"><img height="15" width="15" style="margin: 0 5px;" src="https://cdn.shopify.com/s/files/1/0612/2258/4473/files/mail.png?v=1653398586" alt=""> ' +
          theme.strings.products_labels_be_notified +
          "</a></span</span>"
      }

      if (item.dataset.preorder == "true" && !item.classList.contains("is-unavailable")) {
        preorderBox.style.display = "flex"
        // set this attribute to "pre_order"

        //settimeout 500ms
        setTimeout(() => {
          addToCartBtn.innerHTML = theme.strings.products_preorder
        }, 50)
      } else if (item.classList.contains("is-unavailable")) {
        preorderBox.style.display = "none"
        setTimeout(() => {
          addToCartBtn.innerHTML = theme.strings.products_labels_sold_out
        }, 50)
      } else {
        preorderBox.style.display = "none"
        setTimeout(() => {
          addToCartBtn.innerHTML = theme.strings.products_product_add_to_cart
        }, 50)
      }

      if (item.dataset.preorderinfo != "") {
        preorderBox.querySelector("p.product__preorder-content").innerHTML = item.dataset.preorderinfo
      }

      if (item.dataset.preorder == "true" && !item.classList.contains("is-unavailable")) {
        button.innerHTML =
          '<span class="tw-font-medium">' + item.dataset.value + "</span>" + statusText + preorderText + dropdownArrow
      } else {
        button.innerHTML = '<span class="tw-font-medium">' + item.dataset.value + "</span>" + statusText + dropdownArrow
      }
    })
  }) /* listItems.foreach */

  $("body").on("click", ".cc-select__option", (event) => {
    if ($(event.currentTarget).has("span.sold-out-label").length != 0) {
      $("#BIS_trigger").click()
      document.querySelector(".buy-buttons-row #BIS_trigger").style.display = "block"
    } else {
      document.querySelector(".buy-buttons-row #BIS_trigger").style.display = "none"
    }
  })

  /* Offcanvas preorder */
  // Open offcanvas.
  $(".button__preorder").click(() => {
    // Disable page-scroll
    $("html, body").css({
      overflow: "hidden",
      height: "100%",
    })
    $(".offcanvas__preorder").animate({
      left: "0",
    })
    $(".offcanvas__overlay").fadeIn()
  })

  // Close offcanvas.
  $(".button__preorder__close").click(() => {
    // Enable page-scroll
    $("html, body").css({
      overflow: "auto",
      height: "auto",
    })
    $(".offcanvas__preorder").animate({
      left: "-500px",
    })
    $(".offcanvas__overlay").fadeOut()
  })

  // Close offcanvas
  $(".offcanvas__overlay").click(() => {
    // Enable page-scroll
    $("html, body").css({
      overflow: "auto",
      height: "auto",
    })
    $(".offcanvas__preorder").animate({
      left: "-500px",
    })
    $(".offcanvas__overlay").fadeOut()
  })

  //   if ($("body").hasClass("template-product")) {
  //     $.get( "https://club.shophelten.dk/rest-api/information.php?shop_id=fashion-by-strand.myshopify.com", function( data ) {
  //       const data_json = JSON.parse(data);
  //       const percentage = data_json.shop_bonus_percentage;

  //     });
  //   }
})

let upsellBtns = document.querySelectorAll(".upsellbtn")
let upsellScroller = document.querySelector(".ed-cart-upsell")
let childWidth = upsellScroller.children[0].offsetWidth

function upsellScrollerFunc(upsellBtn) {
  if (upsellBtn.id == "left-scroll") {
    upsellScroller.style.scrollBehavior = "smooth"
    upsellScroller.scrollLeft -= childWidth
    upsellScroller.style.scrollBehavior = "unset"
  } else if (upsellBtn.id == "right-scroll") {
    upsellScroller.style.scrollBehavior = "smooth"
    upsellScroller.scrollLeft += childWidth
    upsellScroller.style.scrollBehavior = "unset"
  }
}

for (let upsellBtn of upsellBtns) {
  upsellBtn.addEventListener("click", function (event) {
    event.preventDefault()
    upsellScrollerFunc(upsellBtn)
  })
}

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    if (event.target.matches(".Avada-CookiesFloat_DenyButtonText")) {
      document.querySelector(".Avada-CookiesFloat_BtnAgree").click()
    }
  })
})

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    if (event.target.matches(".Avada-CookiesMobile_DenyButtonText")) {
      document.querySelector(".Avada-CookiesMobile_BtnAgree").click()
    }
  })
})

// Testimonial Slider Section

class testimonalSection extends HTMLElement {
  constructor() {
    super()

    const testimonialSlider = this
    const testimonialSliderCards = this.querySelectorAll(".card_slide")
    const sliderCardsWidth = testimonialSliderCards[0].offsetWidth + 35

    const sliderBtns = this.closest(".slidercontainered").querySelectorAll(".sliderbtn")

    for (let sliderBtn of sliderBtns) {
      sliderBtn.addEventListener("click", function () {
        if (sliderBtn.getAttribute("data-id") == "right") {
          testimonialSlider.scrollLeft += sliderCardsWidth
        } else {
          testimonialSlider.scrollLeft -= sliderCardsWidth
        }
      })
    }
  }
}

customElements.define("ed-testimonial-slider", testimonalSection)







function initializeCartUpdateListener() {
  document.documentElement.dispatchEvent(new CustomEvent("theme:cartchanged", { bubbles: true, cancelable: false }));
  console.log("cart changed");
}


window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    setTimeout(() => {
      initializeCartUpdateListener();
    }, 1500);
  }
});